<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content *ngIf="pairingMap">
  <div class="control-item-component" *ngIf='complianceArea != null && complianceArea.complianceAreaId != null'>
    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Edit Framework: {{complianceArea.name}}</h2>
      </mat-card-title>
      <mat-card-content [formGroup]="form">

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >

          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Item</mat-label>
              <input matInput  name="name" [(ngModel)]="complianceArea.name" formControlName="name">
            </mat-form-field>
          </div>

        </div>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <div style="flex:49%">
            <mat-checkbox [(ngModel)]="complianceArea.isExtended" formControlName="isExtended">Extended</mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <div style="flex:49%">
            <mat-checkbox [(ngModel)]="complianceArea.hasLevels" formControlName="hasLevels">Has Levels</mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             *ngIf="tenantPermissions.isSecurityAssessmentTabEnabled"
        >
          <div style="flex:300px">
            <mat-form-field>
              <mat-label>Security Assessment Visibility</mat-label>
              <mat-select [(ngModel)]="complianceArea.securityAssessmentVisibility"
                          formControlName="securityAssessmentVisibility"
                          >
                <mat-option [value]="0">Hidden</mat-option>
                <mat-option [value]="1">Advisors Only</mat-option>
                <mat-option [value]="2">Visible</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             *ngIf="tenantPermissions.isRiskAssessmentTabEnabled"
        >
          <div style="flex:300px">
            <mat-form-field>
              <mat-label>Risk Assessment Visibility</mat-label>
              <mat-select [(ngModel)]="complianceArea.riskAssessmentVisibility"
                          formControlName="riskAssessmentVisibility"
                          >
                <mat-option [value]="0">Hidden</mat-option>
                <mat-option [value]="1">Advisors Only</mat-option>
                <mat-option [value]="2">Visible</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <div style="flex:49%">
            <mat-checkbox [(ngModel)]="complianceArea.isFedRamp" formControlName="isFedRamp">Display FedRAMP Control
              Information
            </mat-checkbox>
          </div>
        </div>

        <div style="display: flex; flex-direction: row;">
          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Max Value for Scoring</mat-label>
              <input matInput  type="number" [(ngModel)]="complianceArea.maxScore"
                     formControlName="maxScore">
            </mat-form-field>
          </div>
        </div>


      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [disabled]="loading" (click)="onSave()" style="border-radius: 6px;">Save</button>
  <img *ngIf="loading"
       src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
